import HekateFormElementValidationDefinition from './HekateFormElementValidationDefinition';
import HekateOptionList from './HekateOptionList';
export default class HekateFormElementDefinition {
    constructor({ id, name, dataType, displayType, displayVariantType, htmlName, optionListId, optionList, validations, }) {
        this.id = id;
        this.name = name;
        this.dataType = dataType;
        this.displayType = displayType;
        this.displayVariantType = displayVariantType || '';
        this.htmlName = htmlName;
        this.validations = (validations || [])
            .map((v) => new HekateFormElementValidationDefinition(v))
            .filter((v) => {
            if (displayType !== 'singleSelect') {
                return true;
            }
            // we only validate required for select to avoid invalidating things like "< $100k" as HTML.
            return v.compareTo(HekateFormElementValidationDefinition.IsRequiredCondition);
        });
        this.optionListId = optionListId;
        this.optionList = HekateOptionList.fromBlob(optionList);
    }
    static fromBlob(blob) {
        const id = blob.id;
        const name = blob.name;
        let dataType;
        let displayType;
        let displayVariantType = '';
        let htmlName;
        if (blob.type === 'FormFieldGroup') {
            dataType = 'none';
            displayType = 'form-field-group';
            htmlName = '';
            try {
                displayVariantType =
                    JSON.parse(blob.style).textType === 'body' ? 'field-group-body' : 'field-group-header';
            }
            catch (e) {
                console.error(e);
            }
        }
        else if (blob.type === 'ProgressiveProfile') {
            dataType = 'none';
            displayType = 'progressive-profile';
            htmlName = '';
        }
        else {
            dataType = blob.dataType;
            displayType = blob.displayType;
            displayVariantType = blob.displayVariantType;
            htmlName = blob.htmlName;
        }
        const optionListId = typeof blob.optionListId !== 'undefined' ? blob.optionListId : '';
        const optionList = typeof blob.optionList !== 'undefined' ?
            HekateOptionList.fromBlob(blob.optionList)
            : HekateOptionList.newEmptyList();
        const validations = blob.validations ?
            blob.validations.map((validationBlob) => HekateFormElementValidationDefinition.fromBlob(validationBlob))
            : [];
        return new HekateFormElementDefinition({
            id,
            name,
            dataType,
            displayType,
            displayVariantType,
            htmlName,
            optionListId,
            optionList,
            validations,
        });
    }
    /** Safely set the optionList value */
    setOptionList(optionList) {
        if (this.optionListId !== optionList.id) {
            throw new Error('Option list ids must match.');
        }
        this.optionList = optionList;
    }
    /** Logically compare (suitable for serialization check) */
    compareTo(rhs) {
        return (this.id === rhs.id &&
            this.htmlName === rhs.htmlName &&
            this.displayType === rhs.displayType &&
            this.displayVariantType === rhs.displayVariantType &&
            this.dataType === rhs.dataType &&
            this.optionListId === rhs.optionListId &&
            this.optionList.compareTo(rhs.optionList) &&
            this.validations.length === rhs.validations.length &&
            !this.validations.find((elm, ii) => !elm.compareTo(rhs.validations[ii])));
    }
}
